import { VUE_APP_BASEURL } from "../../utils/api";
import axios from "axios";
import store from "../../store";
//import router from "../../router";
const state = {
    status: "",
    registerResponse: "",
    loginResponse: "",
    userToken: localStorage.getItem("user-token") || "",
    cartToken: localStorage.getItem("cart-token") || "",
    carts: [],
    cartResponse: "",
    orderResponse: "",
    address: "",
    locality: "",
    orderStatus: "",
    addressStatus: "",
    addressResponse: "",
    orders: [],
    orderDetails: [],
    cartCount: 0,
}

const getters = {
    getRegisterStatus: state => state.status,
    getRegisterResponse: state => state.registerResponse,
    getLoginStatus: state => state.status,
    getLoginResponse: state => state.loginResponse,
    getCartToken: state => state.cartToken,
    isAuthenticated: state => !!state.userToken,
    getUserToken: state => state.userToken,
    getCart: (state) => state.carts,
    getCartStatus: state => state.status,
    getCartResponse: state => state.cartResponse,
    getAddress: state => state.address,
    getLocality: state => state.locality,
    getOrderStatus: state => state.orderStatus,
    getOrderResponse: state => state.orderResponse,
    getAddressStatus: state => state.addressStatus,
    getAddressResponse: state => state.addressResponse,
    getOrders: state => state.orders,
    getOrderDetails: state => state.orderDetails,
    getCartCount: state => state.cartCount,
}

const actions = {

    //customer register
    async registerAction({ commit }, customerData) {
        axios({
            method: "POST",
            url: VUE_APP_BASEURL + "customer/register/" + store.getters.UserLocation,
            data: {
                name: customerData.name,
                mobile: customerData.mobileno,
                password: customerData.password,
            },
        })
            .then(function (response) {
                //console.log(response);
                commit("authSuccess");
                commit("registerReturnResponse", response.data);
            })
            .catch(function (error) {
                console.log(error.response);
                commit("authError");
                commit("registerReturnResponse", error.response.data);
            });
    },

    async loginAction({ commit }, loginData) {
        axios({
            method: "POST",
            url: VUE_APP_BASEURL + "customer/login",
            data: {
                mobile: loginData.mobileno,
                password: loginData.password,
                orderkey: store.getters.getCartToken,
            },
        })
            .then(function (response) {
                console.log(response.data);
                if (response.data.status == true) {
                    commit("authSuccess");
                    commit("loginReturnResponse", response.data);
                    localStorage.setItem("cart-token", response.data.response.customer.orderkey);
                    commit("setCarttoken", response.data.response.customer.orderkey);
                    localStorage.setItem("user-token", response.data.response.customer.token);
                    localStorage.setItem("user-name", response.data.response.customer.name);
                    localStorage.setItem('currentLocation', response.data.response.customer.location_id);

                    location.reload();
                    //router.push("/cart");
                    //router.addRoute("/cart");
                }

            })
            .catch(function (error) {
                console.log(error.response);
                //console.log(error.response.data.response);
                commit("authError");
                commit("loginErrorReturnResponse", error.response.data);
            });
    },
    async brandLoginAction({ commit }, loginData) {
        axios({
            method: "POST",
            url: VUE_APP_BASEURL + "customer/login",
            data: {
                mobile: loginData.mobileno,
                password: loginData.password,
                orderkey: store.getters.getCartToken,
            },
        })
            .then(function (response) {
                console.log(response.data);
                if (response.data.status == true) {
                    commit("authSuccess");
                    commit("loginReturnResponse", response.data);
                    localStorage.setItem("cart-token", response.data.response.customer.orderkey);
                    commit("setCarttoken", response.data.response.customer.orderkey);
                    localStorage.setItem("user-token", response.data.response.customer.token);
                    localStorage.setItem("user-name", response.data.response.customer.name);
                    localStorage.setItem('currentLocation', response.data.response.customer.location_id);

                    location.reload();
                    // router.push("/cart");
                    //router.addRoute("/cart");
                }

            })
            .catch(function (error) {
                console.log(error.response);
                //console.log(error.response.data.response);
                commit("authError");
                commit("loginErrorReturnResponse", error.response.data);
            });
    },

    //product add to cart
    async addTocart({ commit, dispatch }, product) {
        //console.log(store.getters.getCartToken);
        //commit("authSuccess");
        axios({
            method: "POST",
            url: VUE_APP_BASEURL + "order/cartadd",
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
            data: {
                orderkey: store.getters.getCartToken,
                product: product.product_id,
                unit: product.unitSelected,
                qty: product.qty,
                fragile: product.fragile,
                organic: product.organic,
                highlight: product.highlight,
                brandpage: store.getters.BrandPage,
                brandslug: store.getters.BrandSlug,
            },
        })
            .then(function (response) {
                //  console.log(response.data);
                if (response.data.status == 1) {
                    // if (!store.getters.getCartToken) {
                        localStorage.setItem("cart-token", response.data.response.order.orderkey);
                        commit("setCarttoken", response.data.response.order.orderkey);
                    // }
                    commit("authSuccess");
                    dispatch("cartDetails");
                    dispatch("cartcount");
                    commit("orderStatusEmpty");
                    commit("authUpdate");
                    if(store.getters.BrandPage == true)
                    {
                        const branddetail = {
                            brandslug: store.getters.BrandSlug,
                            brandstore: true,
                        };
                        dispatch("getBrandDetails",branddetail);
                    }


                }
            })
            .catch(function (error) {
                if(error.response.data.message != 'No Stock')
                {
                    commit("authError");
                    commit("cartError");
                    commit("cartReturnResponse", error.response.data);
                }
            });
    },

    //cart Item Count
    async cartcount({ commit }) {

        axios({
            method: "POST",
            url: VUE_APP_BASEURL + "order/cartcount",
            data: {
                orderkey: store.getters.getCartToken,
            },
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                // console.log(response.data.response.cart);
                // console.log('123');
                commit("authSuccess");
                commit("setCartCount",response.data.response.cart);
                commit("authUpdate");
            })
            .catch(function (error) {
                console.log(error.response);
            });
    },

    //cart Item Delete
    async removeFromcart({ commit, dispatch }, product) {

        axios({
            method: "POST",
            url: VUE_APP_BASEURL + "order/removecart",
            data: {
                orderkey: store.getters.getCartToken,
                product: product.product_id,
                unit: product.unitSelected,
            },
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                console.log(response);
                commit("authSuccess");
                dispatch("cartDetails");
                dispatch("cartcount");
                commit("authUpdate");
            })
            .catch(function (error) {
                console.log(error.response);
            });
    },

    //cart Clear
    async ClearCart({ commit, dispatch }) {

        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "order/clearcart/"+store.getters.getCartToken,
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                console.log(response);
                commit("authSuccess");
                dispatch("cartDetails");
                dispatch("cartcount");
                commit("authUpdate");
            })
            .catch(function (error) {
                console.log(error.response);
            });
    },

    //get customer cart details
    async cartDetails({ commit }) {
        //console.log(store.getters.getCartToken);
        commit("authRequest");
        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "order/cartlist?orderkey=" + store.getters.getCartToken + "&customer=",
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                //console.log(response);
                commit("setCartdetails", response.data.response);
                commit("authSuccess");
            })
            .catch(function (error) {
                commit("authError");
                console.log(error.response);
            });
    },
    //Order Confirm
    async orderConfirm({ commit, dispatch }, orderData) {

        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "order/converttoorder/" + store.getters.getCartToken + '?brand=' + orderData.brandslug,
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                console.log(response);
                if (response.data.status == 1) {
                    commit("authSuccess");
                    commit("orderSuccessResponse", response.data.response);
                    dispatch("cartDetails");
                    dispatch("cartcount");
                    commit("authUpdate");
                }


            })
            .catch(function (error) {
                console.log(error.response);
                commit("authError");
                commit("orderError", error.response.data.response);
            });
    },
    async addressDetails({ commit }) {
        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "customer/address",
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                //  console.log(response);
                commit("setAddressdetails", response.data.response);
                commit("authSuccess");
            })
            .catch(function (error) {
                console.log(error.response);
            });
    },

    async addressUpdate({ commit, dispatch }, addressData) {
        axios({
            method: "POST",
            url: VUE_APP_BASEURL + "customer/addressupdate",
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
            data: {
                name: addressData.name,
                email: addressData.email,
                flat_door_no: addressData.flat_door_no,
                address: addressData.address,
                address2: addressData.address2,
                locality_id: addressData.locality_id,
                pincode: addressData.pincode,
                geo_location: addressData.geo_location,
            },
        })
            .then(function (response) {
                console.log(response.data);
                dispatch("addressDetails");
                commit("addressReturnResponse", response.data.message);
            })
            .catch(function (error) {
                console.log(error.response);
                //console.log(error.response.data.response);
                commit("authError");
                commit("addressError", error.response.data.response);
            });
    },

    async orders({ commit }) {
        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "customer/order",
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                //console.log(response);
                commit("setOrders", response.data.response.order);
                commit("authSuccess");
            })
            .catch(function (error) {
                console.log(error.response);
            });
    },

    async orderDetails({ commit }, orderId) {
        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "customer/orderdetail/" + orderId,
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                console.log(response);
                commit("setOrderDetails", response.data.response.order);
                commit("authSuccess");
            })
            .catch(function (error) {
                console.log(error.response);
            });
    },

    async logoutAction({ commit }) {
        commit("authLogout");
        localStorage.removeItem("user-token");
        localStorage.removeItem("cart-token");
        localStorage.removeItem("user-name");
        //router.push("/");
        location.reload();
    },

}

const mutations = {
    authRequest: state => {
        state.status = "loading";
    },
    authSuccess: (state) => {
        state.status = "success";
    },
    authError: (state) => {
        state.status = "error";
    },
    cartError: (state) => {
        state.status = "error";
    },
    authUpdate: (state) => {
        state.status = "";
    },
    registerReturnResponse: (state, resp) => {
        state.registerResponse = resp;
    },
    loginReturnResponse: (state, resp) => {
        state.loginResponse = resp.response;
        state.userToken = resp.response.customer.token;
    },
    loginErrorReturnResponse: (state, resp) => {
        state.loginResponse = resp.response;
    },
    setCarttoken: (state, resp) => {
        state.cartToken = resp;
    },
    setCartdetails: (state, resp) => {
        state.carts = resp.cart;
    },
    setAddressdetails: (state, resp) => {
        state.address = resp.user;
        state.locality = resp.locality;
    },
    cartReturnResponse: (state, resp) => {
        state.cartResponse = resp.response;
    },
    setCartCount: (state, resp) => {
        state.cartCount = resp;
    },
    orderSuccessResponse: (state, resp) => {
        localStorage.setItem("cart-token", "");
        state.cartToken = "";
        state.orderStatus = "success";
        state.orderResponse = resp;
    },
    orderError: (state, resp) => {
        state.orderStatus = "error";
        state.orderResponse = resp;
    },
    authLogout: (state) => {
        console.log("logout");
        localStorage.setItem("user-token", "");
        localStorage.setItem("cart-token", "");
        state.cartToken = "";
        state.userToken = "";

    },
    updateCustomerName: (state, name) => {
        state.address.name = name;
    },
    updateCustomerEmail: (state, email) => {
        state.address.email = email;
    },
    updateCustomerFlat: (state, flatno) => {
        state.address.flat_door_no = flatno;
    },
    updateCustomerAddress: (state, address) => {
        state.address.address = address;
    },
    updateCustomerAddress2: (state, address2) => {
        state.address.address2 = address2;
    },
    updateCustomerLocalityId: (state, localityId) => {
        state.address.locality_id = localityId;
    },
    updateCustomerPincode: (state, pincode) => {
        state.address.pincode = pincode;
    },
    updateCustomerGeoLocation: (state, geo_location) => {
        state.address.geo_location = geo_location;
    },
    addressReturnResponse: (state, resp) => {
        state.addressStatus = "success";
        state.addressResponse = resp;
    },
    addressError: (state, resp) => {
        state.addressStatus = "error";
        state.addressResponse = resp;
    },
    setOrders: (state, resp) => {
        state.orders = resp;
    },
    setOrderDetails: (state, resp) => {
        state.orderDetails = resp;
    },
    orderStatusEmpty: (state) => {
        state.orderStatus = "";
    },
}

export default {
    state,
    getters,
    actions,
    mutations
};